// @ts-ignore
import AdSense from 'react-adsense';

export default function GoogleADSense() {
  return (
    <AdSense.Google
      client="ca-pub-8352043502333695"
      slot="4651508651"
      style={{ display: 'block', textAlign: 'center', marginTop: '10px' }}
    />
  )
}